import * as types from '../types/wishlistTypes';
import { WISHLIST_STORAGE_KEY } from '../constants/storageKeys';

function loadWishlistIds() {
  try {
    const raw = localStorage.getItem(WISHLIST_STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return [];
    return [...new Set(parsed.map((x) => String(x)))];
  } catch {
    return [];
  }
}

const initialState = {
  ids: loadWishlistIds(),
};

const wishlistReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.WISHLIST_TOGGLE_ID: {
      const id = String(action.payload ?? '').trim();
      if (!id) return state;
      const idx = state.ids.indexOf(id);
      if (idx >= 0) {
        const ids = [...state.ids];
        ids.splice(idx, 1);
        return { ...state, ids };
      }
      return { ...state, ids: [...state.ids, id] };
    }
    case types.WISHLIST_REMOVE_ID: {
      const id = String(action.payload ?? '');
      return { ...state, ids: state.ids.filter((x) => x !== id) };
    }
    case types.WISHLIST_CLEAR:
      return { ...state, ids: [] };
    default:
      return state;
  }
};

export default wishlistReducer;
